import NavbarFacach from "../components/NavbarFacach";
import FooterFacach from "../components/FooterFacach";
import SocialBar from "../components/SocialBar";
import NoticiasPlaceholder from "../components/NoticiasPlaceholder";
import React from "react";

export default function Noticias(){
    return(
        <>
            <NavbarFacach/>
            <NoticiasPlaceholder
                title="NOTICIAS | MOVIMIENTO COOPERATIVO"
                totalItems={40}
                initialPageSize={16}
            />
            <FooterFacach/>
            <SocialBar/>
        </>
    );
}